import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import ScreeningService from '../ScreeningService'

export const getScreeningIndicators = createAsyncThunk(
  'tool/screening/getScreeningIndicators',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScreeningService.getScreeningIndicators(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getVSIC = createAsyncThunk(
  'tool/screening/getVSIC',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScreeningService.getVSIC(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getICB = createAsyncThunk(
  'tool/screening/getICB',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScreeningService.getICB(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getYearReports = createAsyncThunk(
  'tool/screening/getYearReports',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScreeningService.getYearReports(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getLocation = createAsyncThunk(
  'tool/screening/getVietnameseLocation',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScreeningService.getVietnameseLocation(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getListingStatus = createAsyncThunk(
  'tool/screening/getListingStatus',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScreeningService.getListingStatus(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getCompanyStatus = createAsyncThunk(
  'tool/screening/getCompanyStatus',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScreeningService.getCompanyStatus(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getLegalForm = createAsyncThunk(
  'tool/screening/getLegalForm',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScreeningService.getLegalForm(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getCompanyType = createAsyncThunk(
  'tool/screening/getCompanyType',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScreeningService.getCompanyType(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const saveCriteria = createAsyncThunk(
  'tool/screening/saveCriteria',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScreeningService.saveCriteria(params)
      if (response.success) return response.data
      return rejectWithValue(response?.errors)
    } catch (error) {
      const errorMessages = error.response.data?.errors
      return rejectWithValue(errorMessages ? errorMessages[0] : null)
    }
  },
)
